import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_sn_img",
  "use": "icon-icon_sn_img-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-icon_sn_img\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h14v14H0z\" /><path d=\"M9.999 3 13 5.007 10.02 7 13 8.993 9.999 11 7 8.994 4.001 11 1 8.992 3.98 7 1 5.007 4.001 3 7 5.005 9.999 3ZM7 5.008 4.022 7 7 8.99 9.978 7 7 5.008Z\" fill=\"#3D7BD8\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol